module.exports = __webpack_public_path__ + "img/such-a-fun-age.639b682e.png";